<template>
  <section id="gallery" class="py-5 bg-white">
    <div class="container">
      <div class="text-center mb-5">
        <h2 class="fw-bold text-dark">Galería de Funcionalidades</h2>
        <p class="mt-2 fs-5 text-muted">Explora las pantallas clave de Medicynia.</p>
      </div>
      <div class="row g-3">
        <div v-for="(image, idx) in images" :key="idx" class="col-lg-3 col-md-4 col-sm-6">
          <div class="gallery-thumbnail" @click="() => showLightbox(idx)">
            <img :src="image.src" :alt="image.title" class="img-fluid rounded shadow-sm">
            <div class="overlay">
              <i class="bi bi-arrows-fullscreen"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <vue-easy-lightbox
      :visible="lightboxVisible"
      :imgs="images"
      :index="lightboxIndex"
      @hide="hideLightbox"
    >
     <template v-slot:prev-btn="{ prev }">
        <button @click="prev" class="lightbox-nav-btn prev"><i class="bi bi-arrow-left-circle-fill"></i></button>
      </template>
      <template v-slot:next-btn="{ next }">
        <button @click="next" class="lightbox-nav-btn next"><i class="bi bi-arrow-right-circle-fill"></i></button>
      </template>
       <template v-slot:close-btn="{ close }">
        <button @click="close" class="lightbox-nav-btn close"><i class="bi bi-x-circle-fill"></i></button>
      </template>
      <!-- Custom toolbar if needed, or title/description display -->
       <template v-slot:toolbar="{ currentImage }">
         <div v-if="currentImage" class="lightbox-toolbar">
           <h5 class="text-white mb-1">{{ currentImage.title }}</h5>
           <!-- <p class="text-white-50 small">{{ currentImage.description }}</p> -->
         </div>
       </template>
    </vue-easy-lightbox>
  </section>
</template>

<script>
import { ref } from 'vue';
import VueEasyLightbox from 'vue-easy-lightbox';

export default {
  name: 'GallerySection',
  components: {
    VueEasyLightbox
  },
  setup() {
    const lightboxVisible = ref(false);
    const lightboxIndex = ref(0);
    const images = ref([]);

    // Generar datos de imágenes dinámicamente
    for (let i = 1; i <= 29; i++) {
      images.value.push({
        src: require(`@/assets/screens/${i}.png`),
        title: `Pantalla ${i}`, // Placeholder title
        description: `Descripción detallada de la funcionalidad mostrada en la pantalla ${i}.` // Placeholder description
      });
    }

    const showLightbox = (index) => {
      lightboxIndex.value = index;
      lightboxVisible.value = true;
    };

    const hideLightbox = () => {
      lightboxVisible.value = false;
    };

    return {
      images,
      lightboxVisible,
      lightboxIndex,
      showLightbox,
      hideLightbox
    };
  }
}
</script>

<style scoped>
.gallery-thumbnail {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  border-radius: 0.375rem; /* Bootstrap's default rounded */
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); /* Softer shadow */
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
}

.gallery-thumbnail img {
  display: block;
  width: 100%;
  height: auto;
  transition: transform 0.3s ease;
}

.gallery-thumbnail:hover img {
  transform: scale(1.05);
}

.gallery-thumbnail:hover {
   transform: translateY(-3px);
   box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}


.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  color: white;
  font-size: 2rem;
}

.gallery-thumbnail:hover .overlay {
  opacity: 1;
}

/* Lightbox Customization */
:deep(.vel-modal) {
  background: rgba(0, 0, 0, 0.85); /* Darker background */
}

.lightbox-nav-btn {
  background: none;
  border: none;
  color: rgba(255, 255, 255, 0.7);
  font-size: 2.5rem;
  padding: 0 1rem;
  cursor: pointer;
  transition: color 0.2s ease;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10; /* Ensure buttons are above image */
}
.lightbox-nav-btn:hover {
  color: white;
}
.lightbox-nav-btn.prev { left: 10px; }
.lightbox-nav-btn.next { right: 10px; }
.lightbox-nav-btn.close {
  top: 15px;
  right: 15px;
  font-size: 2rem;
  transform: none; /* Override vertical centering */
}

.lightbox-toolbar {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px 20px;
  border-radius: 5px;
  text-align: center;
  max-width: 80%;
}

</style>
